module.exports = __webpack_public_path__ + "static/img/default-thumb@3x.78f6293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-thumb@3x.png
// module id = 218
// module chunks = 382